import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface GenerateIFRSQuestionIdResponseData {
  id: string;
}

export interface GenerateIFRSQuestionIdResponse {
  message: string;
  data: GenerateIFRSQuestionIdResponseData;
}

type GenerateIFRSQuestionIdAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: GenerateIFRSQuestionIdResponse;
};

export const GenerateIFRSQuestionId = async (
  ifrsId: string
): Promise<GenerateIFRSQuestionIdAPIResponse> => {
  try {
    const response = await axios.post(`/ifrs/${ifrsId}/questions`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

